import { useQuery } from '@tanstack/react-query';

import { PluginEquifaxInDepthTradingHistoryFormResponse } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runEquifaxInDepthTradingHistoryForm } from '../../requests/runEquifaxInDepthTradingHistoryForm';

export const useEquifaxInDepthTradingHistoryForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    | NonPaginatedResponse<PluginEquifaxInDepthTradingHistoryFormResponse>
    | undefined
  >({
    queryKey: [
      PLUGIN_BASE_PATH,
      'equifax-in-depth-trading-history-form',
      applicationUuid,
    ],
    queryFn: () =>
      runEquifaxInDepthTradingHistoryForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
